/**
 * Toucan People — the handle on the open app. The store is the source of truth
 * for everything saved; a page's own unsaved state (the form's draft, the
 * review session, where the lightbox has got to) belongs to that page's
 * component.
 */

import { required } from "toucan";
import type { ToucanApp } from "toucan";
import type { PeopleStore } from "./model.ts";

let current: ToucanApp<PeopleStore> | null = null;

/** Hand the pages the app `main()` has just opened. */
export function setApp(opened: ToucanApp<PeopleStore>): void {
  current = opened;
}

/**
 * Close the open store and forget it — what leaving the page would do, if a
 * page ever left. The suite does it between tests: an open store keeps
 * listeners on the window for coming back online and for the tab being looked
 * at again, and those outlive the tree that was rendered from it.
 */
export function closeApp(): void {
  current?.close();
  current = null;
}

/** The open app. Every caller runs after boot, so it is always there. */
export function app(): ToucanApp<PeopleStore> {
  return required(current, "app");
}

/** Shorthand for the synced store — by far the most-read thing on `app()`. */
export function store(): PeopleStore {
  return app().store;
}
